import {IOption} from "@pg-design/select-module";

import {GetRegionDetailsDto} from "@/features/regions/types/GetRegionDetailsDto";

import {HomeMatchSurveyDto, IHomeMatchUserPreferencesForm} from "../types/home_match_preferences";
import {getRoomsRangeValues} from "./home_match_rooms_range";

export const transformHomeMatchApiIntoFormData = (data: HomeMatchSurveyDto, regionDetails: GetRegionDetailsDto[] = []): IHomeMatchUserPreferencesForm => {
    const regionDetailsMap = new Map(regionDetails.map((region) => [region.id as number, region]));

    const regions: IOption<number>[] = data.regions.map((regionId) => {
        const regionDetail = regionDetailsMap.get(regionId);
        return {
            value: regionId,
            label: regionDetail?.short_name || regionDetail?.name || `Region ${regionId}`
        };
    });

    return {
        regions,
        price: data.price,
        rooms: data.rooms ? getRoomsRangeValues(data.rooms) : null,
        financing_services: Boolean(data.financing_services)
    };
};
import {IOption} from "@pg-design/select-module";

import {GetRegionDetailsDto} from "@/features/regions/types/GetRegionDetailsDto";

import {HomeMatchSurveyDto, IHomeMatchUserPreferencesForm} from "../types/home_match_preferences";
import {getRoomsRangeValues} from "./home_match_rooms_range";

export const transformHomeMatchApiIntoFormData = (data: HomeMatchSurveyDto, regionDetails: GetRegionDetailsDto[] = []): IHomeMatchUserPreferencesForm => {
    const regionDetailsMap = new Map(regionDetails.map((region) => [region.id as number, region]));

    const regions: IOption<number>[] = data.regions.map((regionId) => {
        const regionDetail = regionDetailsMap.get(regionId);
        return {
            value: regionId,
            label: regionDetail?.short_name || regionDetail?.name || `Region ${regionId}`
        };
    });

    return {
        regions,
        price: data.price,
        rooms: data.rooms ? getRoomsRangeValues(data.rooms) : null,
        financing_services: Boolean(data.financing_services)
    };
};
